import React from 'react';
import { Icon } from './Icon.js';
export const IconPenWriting2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 6L18 11", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 21L21.5 7.5L16.5001 2.50006L3 16L3.00002 21L8 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 22H11.2432L13.2441 20H22V22Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconPenWriting2.js.map